/**
 * Defines the constants used by the Jobs module.
 * @file
 * @author Benjamin Listwon <ben@thebrandingfarm.com>
 * @author Jason Haddix <jason@thebrandingfarm.com>
 */
export const VUEX_JOBS_GET_REQUEST_FOR_EXCEL                     = 'VUEX_JOBS_GET_REQUEST_FOR_EXCEL'
export const VUEX_JOBS_GET_REQUEST                               = 'VUEX_JOBS_GET_REQUEST'
export const VUEX_JOBS_GET_SUCCESS                               = 'VUEX_JOBS_GET_SUCCESS'
export const VUEX_JOBS_GET_FAILURE                               = 'VUEX_JOBS_GET_FAILURE'
export const VUEX_JOB_DELETE                                     = 'VUEX_JOB_DELETE'
export const VUEX_JOBS_SET_APPROVED                              = 'VUEX_JOBS_SET_APPROVED'
export const VUEX_JOBS_SET_DEEPSTATE                             = 'VUEX_JOBS_SET_DEEPSTATE'

export const VUEX_JOBS_EXIT_JOBS                                 = 'VUEX_JOBS_EXIT_JOBS'
export const VUEX_JOBS_EXIT_JOB                                  = 'VUEX_JOBS_EXIT_JOB'

export const VUEX_JOBS_APPLY_FILTERS_ONE_VALUE_ONLY              = 'VUEX_JOBS_APPLY_FILTERS_ONE_VALUE_ONLY'
export const VUEX_JOBS_APPLY_FILTERS                             = 'VUEX_JOBS_APPLY_FILTERS'
export const VUEX_JOBS_CLEAR_FILTERS                             = 'VUEX_JOBS_CLEAR_FILTERS'
export const VUEX_JOBS_RESET_FILTERS                             = 'VUEX_JOBS_RESET_FILTERS'
export const VUEX_JOBS_SET_FILTER_TOGGLER                        = 'VUEX_JOBS_SET_FILTER_TOGGLER'
export const VUEX_JOBS_STORE_QUICK_FILTER                        = 'VUEX_JOBS_STORE_QUICK_FILTER'
export const VUEX_JOBS_APPLY_FILTER_BY_NAME                      = 'VUEX_JOBS_APPLY_FILTER_BY_NAME'
export const VUEX_JOBS_REMOVE_APPLIED_FILTER_BY_NAME             = 'VUEX_JOBS_REMOVE_APPLIED_FILTER_BY_NAME'

export const VUEX_JOBS_APPLY_USER_ME_IN_ROLE                     = 'VUEX_JOBS_APPLY_USER_ME_IN_ROLE'
export const VUEX_JOBS_REMOVE_USER_ME_IN_ROLE                    = 'VUEX_JOBS_REMOVE_USER_ME_IN_ROLE'
export const VUEX_JOBS_REMOVE_USER_ALL_REQUESTS_MY_DRAFTS        = 'VUEX_JOBS_REMOVE_USER_ALL_REQUESTS_MY_DRAFTS'

export const VUEX_JOBS_APPLY_ARCHIVE_FILTER                      = 'VUEX_JOBS_APPLY_ARCHIVE_FILTER'
export const VUEX_JOBS_APPLY_STATUS_FILTER                       = 'VUEX_JOBS_APPLY_STATUS_FILTER'
export const VUEX_JOBS_APPLY_PROGRESS_FILTER                     = 'VUEX_JOBS_APPLY_PROGRESS_FILTER'
export const VUEX_JOBS_APPLY_PROGRESS_NOTE_FILTER                = 'VUEX_JOBS_APPLY_PROGRESS_NOTE_FILTER'
export const VUEX_JOBS_APPLY_TYPE_FILTER                         = 'VUEX_JOBS_APPLY_TYPE_FILTER'
export const VUEX_JOBS_APPLY_DEPARTMENT_FILTER                   = 'VUEX_JOBS_APPLY_DEPARTMENT_FILTER'
export const VUEX_JOBS_APPLY_DUE_FILTER                          = 'VUEX_JOBS_APPLY_DUE_FILTER'
export const VUEX_JOBS_APPLY_CREATIVE_ROUND_FILTER               = 'VUEX_JOBS_APPLY_CREATIVE_ROUND_FILTER'

export const VUEX_JOBS_APPLY_USER_REQUESTOR                      = 'VUEX_JOBS_APPLY_USER_REQUESTOR'
export const VUEX_JOBS_APPLY_USER_PROJECT_MANAGER                = 'VUEX_JOBS_APPLY_USER_PROJECT_MANAGER'
export const VUEX_JOBS_APPLY_USER_PRINT_PROJECT_MANAGER          = 'VUEX_JOBS_APPLY_USER_PRINT_PROJECT_MANAGER'
export const VUEX_JOBS_APPLY_USER_PREMEDIA_PROJECT_MANAGER       = 'VUEX_JOBS_APPLY_USER_PREMEDIA_PROJECT_MANAGER'
export const VUEX_JOBS_APPLY_USER_PREMEDIA_ART_DIRECTOR          = 'VUEX_JOBS_APPLY_USER_PREMEDIA_ART_DIRECTOR'
export const VUEX_JOBS_APPLY_USER_CREATIVE                       = 'VUEX_JOBS_APPLY_USER_CREATIVE'


export const VUEX_JOBS_SYNC_PAGINATION                           = 'VUEX_JOBS_SYNC_PAGINATION'
export const VUEX_JOBS_SYNC_PAGINATION_SORT                      = 'VUEX_JOBS_SYNC_PAGINATION_SORT'
export const VUEX_JOBS_APPLY_DEEPSTATE                           = 'VUEX_JOBS_APPLY_DEEPSTATE'
export const VUEX_JOBS_APPLY_QUICK_FILTER                        = 'VUEX_JOBS_APPLY_QUICK_FILTER'
export const VUEX_JOBS_TEXT_FILTER_SEARCH                        = 'VUEX_JOBS_TEXT_FILTER_SEARCH'
export const VUEX_JOBS_CLEAR_TEXT_FILTER_SEARCH                  = 'VUEX_JOBS_CLEAR_TEXT_FILTER_SEARCH'
export const VUEX_JOBS_SET_PAGINATION_PER_PAGE                   = 'VUEX_JOBS_SET_PAGINATION_PER_PAGE'
export const VUEX_JOBS_GET_PROGRESSES_REQUEST                    = 'VUEX_JOBS_GET_PROGRESSES_REQUEST'

// Job UUID Get
export const VUEX_JOB_GET_REQUEST                                = 'VUEX_JOB_GET_REQUEST'
export const VUEX_JOB_GET_SUCCESS                                = 'VUEX_JOB_GET_SUCCESS'
export const VUEX_JOB_GET_FAILURE                                = 'VUEX_JOB_GET_FAILURE'

// Job Update
export const VUEX_JOB_UPDATE_PROP                                = 'VUEX_JOB_UPDATE_PROP'
export const VUEX_JOB_UPDATE_DELIVERY_OPTION_PROP                = 'VUEX_JOB_UPDATE_DELIVERY_OPTION_PROP'
export const VUEX_JOB_UPDATE_DELVIERY_OPTION_REQUEST             = 'VUEX_JOB_UPDATE_DELVIERY_OPTION_REQUEST'
export const VUEX_JOB_UPDATE_REQUEST                             = 'VUEX_JOB_UPDATE_REQUEST'
export const VUEX_JOB_UPDATE_REQUEST_SUCCESS                     = 'VUEX_JOB_UPDATE_REQUEST_SUCCESS'
export const VUEX_JOB_UPDATE_REQUEST_FAILURE                     = 'VUEX_JOB_UPDATE_REQUEST_FAILURE'
export const VUEX_JOB_SAVE_JOB_NAME                              = 'VUEX_JOB_SAVE_JOB_NAME'

// Comments
export const VUEX_JOB_GET_COMMENTS                               = 'VUEX_JOB_GET_COMMENTS'
export const VUEX_JOB_GET_COMMENTS_SUCCESS                       = 'VUEX_JOB_GET_COMMENTS_SUCCESS'
export const VUEX_JOB_GET_COMMENTS_FAILURE                       = 'VUEX_JOB_GET_COMMENTS_FAILURE'
export const VUEX_JOB_GET_COMMENTS_ABORT                         = 'VUEX_JOB_GET_COMMENTS_ABORT'
export const VUEX_JOB_GET_COMMENT                                = 'VUEX_JOB_GET_COMMENT'
export const VUEX_JOB_GET_COMMENTS_NEXT_PAGE_REQUEST             = 'VUEX_JOB_GET_COMMENTS_NEXT_PAGE_REQUEST'
export const VUEX_JOB_ADD_COMMENT                                = 'VUEX_JOB_ADD_COMMENT'
export const VUEX_JOB_GET_COMMENT_SUCCESS                        = 'VUEX_JOB_GET_COMMENT_SUCCESS'
export const VUEX_JOB_ADD_COMMENT_SUCCESS                        = 'VUEX_JOB_ADD_COMMENT_SUCCESS'
export const VUEX_JOB_ADD_UNPUBLISHED_COMMENT                    = 'VUEX_JOB_ADD_UNPUBLISHED_COMMENT'         // for file attachment (see below as well)
export const VUEX_JOB_ADD_UNPUBLISHED_COMMENT_SUCCESS            = 'VUEX_JOB_ADD_UNPUBLISHED_COMMENT_SUCCESS' // for file attachment (see below as well)
export const VUEX_JOB_CLEAR_UNPUBLISHED_COMMENT                  = 'VUEX_JOB_CLEAR_UNPUBLISHED_COMMENT'       // for file attachment (see below as well)
export const VUEX_JOB_UPDATE_UNPUBLISHED_COMMENT_TEXT           = 'VUEX_JOB_UPDATE_UNPUBLISHED_COMMENT_TEXT'
export const VUEX_JOB_UPDATE_UNPUBLISHED_COMMENT_SET_HAS_ATTACHMENTS = 'VUEX_JOB_UPDATE_UNPUBLISHED_COMMENT_SET_HAS_ATTACHMENTS'
export const VUEX_JOB_SET_TEARDOWN_COMMENT_FLAG                  = 'VUEX_JOB_SET_TEARDOWN_COMMENT_FLAG'
export const VUEX_JOB_CLEAR_TEARDOWN_COMMENT_FLAG                = 'VUEX_JOB_CLEAR_TEARDOWN_COMMENT_FLAG'
export const VUEX_JOB_UPDATE_COMMENT                             = 'VUEX_JOB_UPDATE_COMMENT'
export const VUEX_JOB_UPDATE_COMMENT_SUCCESS                     = 'VUEX_JOB_UPDATE_COMMENT_SUCCESS'
export const VUEX_JOB_REMOVE_COMMENT                             = 'VUEX_JOB_REMOVE_COMMENT'
export const VUEX_JOB_REMOVE_COMMENT_SUCCESS                     = 'VUEX_JOB_REMOVE_COMMENT_SUCCESS'

// Team
export const VUEX_JOB_GET_TEAM                                   = 'VUEX_JOB_GET_TEAM'
export const VUEX_JOB_TEAM_ADD_MEMBER                            = 'VUEX_JOB_TEAM_ADD_MEMBER'
export const VUEX_JOB_TEAM_ADD_MEMBER_SUCCESS                    = 'VUEX_JOB_TEAM_ADD_MEMBER_SUCCESS'
export const VUEX_JOB_TEAM_ADD_MEMBER_FAILURE                    = 'VUEX_JOB_TEAM_ADD_MEMBER_FAILURE'
export const VUEX_JOB_TEAM_REMOVE_MEMBER                         = 'VUEX_JOB_TEAM_REMOVE_MEMBER'
export const VUEX_JOB_TEAM_REMOVE_MEMBER_SUCCESS                 = 'VUEX_JOB_TEAM_REMOVE_MEMBER_SUCCESS'
export const VUEX_JOB_TEAM_REMOVE_MEMBER_FAILURE                 = 'VUEX_JOB_TEAM_REMOVE_MEMBER_FAILURE'
export const VUEX_JOB_GET_WATCHES                                = 'VUEX_JOB_GET_WATCHES'
export const VUEX_JOB_GET_WATCHES_SUCCESS                        = 'VUEX_JOB_GET_WATCHES_SUCCESS'

// Files (Deprecating)
export const VUEX_JOB_GET_FILES                                  = 'VUEX_JOB_GET_FILES'
export const VUEX_JOB_GET_FILES_SUCCESS                          = 'VUEX_JOB_GET_FILES_SUCCESS'

// Watch + Flag
export const VUEX_JOB_WATCH                                      = 'VUEX_JOB_WATCH'
export const VUEX_JOB_WATCH_SUCCESS                              = 'VUEX_JOB_WATCH_SUCCESS'
export const VUEX_JOB_UNWATCH                                    = 'VUEX_JOB_UNWATCH'
export const VUEX_JOB_UNWATCH_SUCCESS                            = 'VUEX_JOB_UNWATCH_SUCCESS'
export const VUEX_JOB_FLAG                                       = 'VUEX_JOB_FLAG'
export const VUEX_JOB_FLAG_SUCCESS                               = 'VUEX_JOB_FLAG_SUCCESS'
export const VUEX_JOB_UNFLAG                                     = 'VUEX_JOB_UNFLAG'
export const VUEX_JOB_UNFLAG_SUCCESS                             = 'VUEX_JOB_UNFLAG_SUCCESS'

// Job Creation Excitement
export const VUEX_JOB_CREATE_INIT                                = 'VUEX_JOB_CREATE_INIT'
export const VUEX_JOB_CREATE_INIT_MILESTONES_DONE                = 'VUEX_JOB_CREATE_INIT_MILESTONES_DONE'
export const VUEX_JOB_CREATE                                     = 'VUEX_JOB_CREATE'
export const VUEX_JOB_CREATE_UI                                  = 'VUEX_JOB_CREATE_UI'
export const VUEX_JOB_CREATE_SUCCESS                             = 'VUEX_JOB_CREATE_SUCCESS'
export const VUEX_JOB_CREATE_FAILURE                             = 'VUEX_JOB_CREATE_FAILURE'
export const VUEX_JOB_CREATE_LOAD                                = 'VUEX_JOB_CREATE_LOAD'
export const VUEX_JOB_CREATE_UPDATE                              = 'VUEX_JOB_CREATE_UPDATE'
export const VUEX_JOB_CREATE_UPDATE_SUCCESS                      = 'VUEX_JOB_CREATE_UPDATE_SUCCESS'
export const VUEX_JOB_CREATE_UPDATE_FAILURE                      = 'VUEX_JOB_CREATE_UPDATE_FAILURE'
export const VUEX_JOB_CREATE_APPLY_TEMPLATE                      = 'VUEX_JOB_CREATE_APPLY_TEMPLATE'
export const VUEX_JOB_CREATE_UPDATE_PROP                         = 'VUEX_JOB_CREATE_UPDATE_PROP'
export const VUEX_JOB_UPDATE_24HOUR_CONFIRMED                    = 'VUEX_JOB_UPDATE_24HOUR_CONFIRMED'
export const VUEX_JOB_CREATE_UPDATE_DELIVERY_OPTION_PROP         = 'VUEX_JOB_CREATE_UPDATE_DELIVERY_OPTION_PROP'
export const VUEX_JOB_CREATE_HAS_CHANGED                         = 'VUEX_JOB_CREATE_HAS_CHANGED'
export const VUEX_JOB_CREATE_CLEAR_PROPS_TO_UPDATE               = 'VUEX_JOB_CREATE_CLEAR_PROPS_TO_UPDATE'
export const VUEX_JOB_CREATE_CLEAR_UPDATED_PROP                  = 'VUEX_JOB_CREATE_CLEAR_UPDATED_PROP'
export const VUEX_JOB_CREATE_CLEAR_DELIVERY_OPTIONS              = 'VUEX_JOB_CREATE_CLEAR_DELIVERY_OPTIONS'
export const VUEX_JOB_CREATE_CANCEL                              = 'VUEX_JOB_CREATE_CANCEL'
export const VUEX_JOB_CREATE_CANCEL_PROMPT                       = 'VUEX_JOB_CREATE_CANCEL_PROMPT'

// Transition (Specific Update)
export const VUEX_JOB_TRANSITION                                 = 'VUEX_JOB_TRANSITION'
export const VUEX_JOB_TRANSITION_SUCCESS                         = 'VUEX_JOB_TRANSITION_SUCCESS'
export const VUEX_JOB_TRANSITION_FAILURE                         = 'VUEX_JOB_TRANSITION_FAILURE'

// Search
export const VUEX_JOB_GET_SEARCH                                 = 'VUEX_JOB_GET_SEARCH'
export const VUEX_JOB_GET_SEARCH_SUCCESS                         = 'VUEX_JOB_GET_SEARCH_SUCCESS'
export const VUEX_JOB_GET_SEARCH_FAILURE                         = 'VUEX_JOB_GET_SEARCH_FAILURE'
export const VUEX_JOB_CLEAR_SEARCH_DATA                          = 'VUEX_JOB_CLEAR_SEARCH_DATA'
export const VUEX_JOB_UPDATE_SEARCH_TERM                         = 'VUEX_JOB_UPDATE_SEARCH_TERM'

// File Attachment
export const VUEX_JOB_ATTACH_FILE                                = 'VUEX_JOB_ATTACH_FILE'
export const VUEX_JOB_REMOVE_FILE_SUCCESS                        = 'VUEX_JOB_REMOVE_FILE_SUCCESS'
export const VUEX_JOB_COMMENT_ATTACH_FILE                        = 'VUEX_JOB_COMMENT_ATTACH_FILE'
export const VUEX_JOB_COMMENT_REMOVE_FILE                        = 'VUEX_JOB_COMMENT_REMOVE_FILE'
export const VUEX_JOB_COMMENT_REMOVE_FILE_SUCCESS                = 'VUEX_JOB_COMMENT_REMOVE_FILE_SUCCESS'
export const VUEX_JOB_GET_ATTACHMENTS                            = 'VUEX_JOB_GET_ATTACHMENTS'
export const VUEX_JOB_GET_ATTACHMENTS_SUCCESS                    = 'VUEX_JOB_GET_ATTACHMENTS_SUCCESS'
export const VUEX_JOB_GET_ATTACHMENTS_FAILURE                    = 'VUEX_JOB_GET_ATTACHMENTS_FAILURE'
export const VUEX_JOB_REMOVE_FILE                                = 'VUEX_JOB_REMOVE_FILE'
export const VUEX_JOB_REMOVE_CHECKED_FILES_CONFIRM               = 'VUEX_JOB_REMOVE_CHECKED_FILES_CONFIRM'

//
// On VUEX_FILE_HANDLE_FILE_NOTIFICATION we use this to surgically replace files
//
export const VUEX_JOB_REPLACE_FILE_ON_COMMENT_ATTACHMENT         = 'VUEX_JOB_REPLACE_FILE_ON_COMMENT_ATTACHMENT'
export const VUEX_JOB_REPLACE_FILE_ON_JOB_ATTACHMENT             = 'VUEX_JOB_REPLACE_FILE_ON_JOB_ATTACHMENT'


export const VUEX_JOBS_ROUTE_CREATIVE_FROM_RESOURCE_ALLOCATION   = 'VUEX_JOBS_ROUTE_CREATIVE_FROM_RESOURCE_ALLOCATION'

//
// Print / PDF
//
export const VUEX_JOB_GENERATE_PRINT_PDF                         = 'VUEX_JOB_GENERATE_PRINT_PDF'
export const VUEX_JOB_PRINT_GET_REQUEST                          = 'VUEX_JOB_PRINT_PRINT_GET_REQEST'
export const VUEX_JOB_PRINT_GET_REQUEST_SUCCESS                  = 'VUEX_JOB_PRINT_PRINT_GET_REQEST_SUCCESS'

//
// LIKE / UNLIKE Comment
//
export const VUEX_JOB_LIKE_COMMENT                               = 'VUEX_JOB_LIKE_COMMENT'
export const VUEX_JOB_UNLIKE_COMMENT                             = 'VUEX_JOB_UNLIKE_COMMENT'

// CANCELS
export const VUEX_JOBS_SET_CANCEL                                = 'VUEX_JOBS_SET_CANCEL'

// UPDATE JOB ATTACHMENT PROPERTIES
export const VUEX_JOBS_UPDATE_JOB_ATTACHMENT_PROPERTIES          = 'VUEX_JOBS_UPDATE_JOB_ATTACHMENT_PROPERTIES'


